import { observer } from "mobx-react-lite";
import styles from "./OtherUsers.module.css";
import { OverlayForNodeContent } from "../../OverlayForNodeContent/OverlayForNodeContent";
import { SaveButton } from "@/components/button/SaveEditCancel/SaveButton";
import { CancelButton } from "@/components/button/SaveEditCancel/CancelButton";
import { InputAndLabelPasswordBox } from "@/components/input/InputAndLabelPasswordBox/InputAndLabelPasswordBox";
import { PermissionsUser } from "../PermissionsUser";
import { InputAndLabelTextBox } from "@/components/input/InputAndLabelTextBox/InputAndLabelTextBox";
import { userStore } from "@/stores/UserStore";
import { User } from "@/types/User.interface";
import { Select } from "@/components/select/Select/Select";
import permissions from "@/data/permissions";
import { useOperationModalForAnotherUsers } from "@/hooks/useOperationModal/useOperationModalForAnotherUser";
import { userAnotherPanelState } from "@/stores/ComponentsState/UserAnotherPanelState";
import { FormAddNewUser } from "./FormAddNewUser/FormAddNewUser";

interface PopupProps {
  user: User;
}

export const Popup = observer(({ user }: PopupProps) => {
  const { modalData, utilsData } = useOperationModalForAnotherUsers();

  function selectNewRole(newRole: number) {
    utilsData.setNewDataAutenticatedUser({
      id: user.id,
      role: newRole,
    });
  }

  function deleteUser(id: number) {
    utilsData.setNewDataAutenticatedUser({ id: id }, "delete-user");
  }

  return (
    modalData?.openModal && (
      <OverlayForNodeContent utilsData={utilsData} modalData={modalData}>
        {userAnotherPanelState.MODAL_TYPE === "role" && (
          <>
            <Select
              style={{ width: "100%" }}
              valueBack={(role: number | string) => userAnotherPanelState.setNewRole(role)}
              defaultValue={userAnotherPanelState.NEW_ROLE}
              listSelect={permissions}
              id={userStore.role!}
            />
            <div className={styles.modalButtons}>
              <SaveButton onClick={() => selectNewRole(userAnotherPanelState.NEW_ROLE)}>
                Изменить роль
              </SaveButton>
              <CancelButton onClick={modalData?.isHide}>Отменить</CancelButton>
            </div>
          </>
        )}
        {userAnotherPanelState.MODAL_TYPE === "delete" && (
          <>
            <div className={styles.modal}>
              <h3>Вы действительно хотите удалить пользователя?</h3>
            </div>
            <div className={styles.modalButtons}>
              {" "}
              <SaveButton onClick={() => deleteUser(user.id)}>Удалить</SaveButton>
              <CancelButton onClick={modalData?.isHide}>Отменить</CancelButton>
            </div>
          </>
        )}

        {userAnotherPanelState.MODAL_TYPE === "password" && (
          <div className={styles.modal}>
            <InputAndLabelPasswordBox
              props={{
                placeholder: "",
                onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                  userAnotherPanelState.setNewPassword(e.target.value),
              }}
              idAndForHTML="np"
              labelText="Введите новый пароль"
            />
            <div className={styles.modalButtons}>
              <SaveButton
                onClick={() =>
                  utilsData.setNewDataAutenticatedUser({
                    id: user.id,
                    new_password: userAnotherPanelState.NEW_PASSWORD,
                  })
                }
              >
                Изменить пароль
              </SaveButton>
              <CancelButton onClick={modalData?.isHide}>Отменить</CancelButton>
            </div>
          </div>
        )}

        {userAnotherPanelState.MODAL_TYPE === "info" && (
          <div className={styles.modal}>
            <PermissionsUser user={user} />
            <div className={styles.modalButtons}>
              <CancelButton onClick={modalData?.isHide}>Ясно, закрыть</CancelButton>
            </div>
          </div>
        )}

        {userAnotherPanelState.MODAL_TYPE === "fio" && (
          <div className={styles.modal}>
            <h3>Новое ФИО</h3>
            <InputAndLabelTextBox
              props={{
                value: userAnotherPanelState.NEW_FIO,
                onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                  userAnotherPanelState.setNewFio(e.target.value),
              }}
              idAndForHTML="newFio"
              labelText="Новое ФИО"
            />

            <div className={styles.modalButtons}>
              <SaveButton
                onClick={() =>
                  utilsData.setNewDataAutenticatedUser({
                    id: user.id,
                    fio: userAnotherPanelState.NEW_FIO,
                  })
                }
              >
                Изменить ФИО
              </SaveButton>
              <CancelButton onClick={modalData?.isHide}>Отменить</CancelButton>
            </div>
          </div>
        )}

        {userAnotherPanelState.MODAL_TYPE === "add" && (
          <FormAddNewUser modalData={modalData} userData={utilsData} />
        )}
      </OverlayForNodeContent>
    )
  );
});
